import httpClient from "./lib/http/index.js";
import unlessElementExists from "./lib/utils/unlessElementExists.js";
import addEventListeners from "./lib/utils/addEventListeners.js";
import {createApp} from "vue";
import CoursesScheduler from "./components/CoursesScheduler.vue";
import UserRegistration from "./components/UserRegistration.vue";
import UserTryRegistration from "./components/UserTryRegistration.vue";
import SliderGallery from "./components/SliderGallery.vue";
import PhotoField from "./components/PhotoField.vue";
import ScheduleTable from "./components/ScheduleTable.vue";
import PasswordField from "./components/PasswordField.vue";
import UserProfile from "./components/UserProfile.vue";
import ViewMoreItems from "./components/ViewMoreItems.vue";
import CookiesNotice from "./components/cookies/CookiesNotice.vue";
import CookiesModal from "./components/cookies/CookiesModal.vue";
import {initAccordions, initModals} from './lib/typhoon/index.js'

httpClient( {
    options : {
        XMLHttpRequest: true,
    },
    headers : {
        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content'),
        'X-AUTH-TOKEN':  document.querySelector('meta[name="auth-token"]')?.getAttribute('content'),
    }
} );

unlessElementExists('.app', container => {
    createApp( {
        components: {
            UserProfile,
            CoursesScheduler,
            UserRegistration,
            UserTryRegistration,
            SliderGallery,
            PhotoField,
            PasswordField,
            ScheduleTable,
            ViewMoreItems,
            CookiesNotice,
            CookiesModal,
        },
        mounted() {
            initAccordions();
            initModals();

            unlessElementExists('.menu', menu => {
                unlessElementExists('#openMenu', button => {
                    let menu_state = false;

                    addEventListeners( button, {
                        click() {
                            menu_state = !menu_state;

                            menu_state ? document.body.classList.add('menu-opened') : document.body.classList.remove('menu-opened');
                            menu_state ? button.classList.add('is-cross') : button.classList.remove('is-cross');
                        }
                    } );
                } );
            } );
        }
    } ).mount( container );
});